export default "__VITE_ASSET__DWOxJUOo__"